import {
  Chevron,
  ChevronWrapper,
  Option,
  Select,
  SelectMultiple,
  SelectWrapper,
} from 'components/_common/dropdown/Dropdown.styles';
import { ReactHtmlParser } from 'helpers/utilities.js';
import PropTypes from 'prop-types';

const Dropdown = ({ selectedValue, handleChange, selectOptions, placeholder, ismultiple, name }) =>
  ismultiple ? (
    <SelectWrapper>
      <SelectMultiple>
        <div className="placeholder-option">{ReactHtmlParser(placeholder)}</div>

        {selectOptions?.map((item, index) => {
          const { value, key } = item;
          return (
            <label key={`${name}_${index}`}>
              {ReactHtmlParser(value)}

              <input
                type="checkbox"
                name={name}
                value={key}
                id={`${name}_${index}`}
                onChange={handleChange}
              />
              <span className="checkmark"></span>
            </label>
          );
        })}
      </SelectMultiple>
    </SelectWrapper>
  ) : (
    <SelectWrapper>
      <Select value={selectedValue} onChange={handleChange}>
        <Option className="placeholder-option" value="" disabled>
          {ReactHtmlParser(placeholder)}
        </Option>
        {selectOptions?.map((item, index) => {
          const { value, key } = item;

          return (
            <Option key={`${value}-${index}`} value={key}>
              {ReactHtmlParser(value)}
            </Option>
          );
        })}
      </Select>
      <ChevronWrapper tabIndex="0">
        <Chevron name="chevron" />
      </ChevronWrapper>
    </SelectWrapper>
  );

Dropdown.propTypes = {
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]), // Allow both string and array
  handleChange: PropTypes.func,
  selectOptions: PropTypes.array,
  placeholder: PropTypes.string,
  ismultiple: PropTypes.bool,
  name: PropTypes.string,
};

export default Dropdown;
